import React from 'react';
import { ScheduleItemProps } from '../../../../../../models/Schedule';
import { AppointmentConfirmationCard } from '../../../../../../components/AppointmentConfirmationCard';

import { ReactComponent as CheckupExecutiveSM } from '../../../../../../assets/check-up-sm.svg';

export const ScheduleCard = ({ schedule }: { schedule: ScheduleItemProps }) => {
  const slots = schedule?.selectedSlotOptions?.[0];

  if (!slots) return null;

  let address = schedule.unit?.address || '';

  if (schedule?.unit?.number) address = address + `, ${schedule.unit.number}`;
  if (schedule?.unit?.neighborhood) address = address + `, ${schedule.unit.neighborhood}`;
  if (schedule?.unit?.city) address = address + `, ${schedule.unit.city}`;
  if (schedule?.unit?.state) address = address + ` - ${schedule.unit.state}`;

  return (
    <AppointmentConfirmationCard
      key={schedule.id}
      patientName={schedule.patientName ?? ''}
      productName={schedule.productName}
      productNameHead={schedule.productName || ''}
      productIconSM={<CheckupExecutiveSM />}
      eligibility={schedule.payment?.eligibility?.plan ?? ''}
      date={new Date(`${slots.date}T${slots.hour}`)}
      productDescription="Check-up"
      unitName={schedule.unit?.name ?? ''}
      unitAddress={address}
      telemedicine={schedule.careType === 'TELEMEDICINE'}
      customCardHead
    />
  );
};
